import { LicenseManager } from '../../../managers/License.manager';
import { License, LicensePackageTypes } from '../../../models/domain/license';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Component, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { AdvancedSearchItem } from '../../../models/domain/advanced.search.item';
import { AdvancedSearchResultMemberItemArray, AdvancedSearchResultMemberItem } from '../../../models/domain/advanced.searche.results';
import { WindowService } from '../../../../app/services/window-dialogs/window.service';
import { SortBot } from '../../../helpers/sort';
import { Member } from '../../../../app/models/domain/member';


@Component({
    selector: 'search-result',
    templateUrl: './search-result.component.html',
    styleUrls: ['./search-result.component.css']
})
export class SearchResultComponent implements OnInit, OnDestroy {

    @Input('IsBusy') IsBusy: boolean = false;


    @Input('SearchResult') AdvancedSearchResult: AdvancedSearchResultMemberItemArray;

    @Input('AdvancedSearch') AdvancedSearch: AdvancedSearchItem;
    // @Input('AdvancedSearchResult')
    @Input('isAdvancedSearch') isAdvancedSearch: boolean = false;
    @Input('searchType') searchType: string = '';

    @Input('firstResult') firstResult: number = 0;
    @Input('lastResult') lastResult: number = 25;
    @Input('SearchInput') SearchInput: string;

    @Output('ItemSelected') ItemSelected = new EventEmitter<boolean>();

    @Output('CheckedItemArrayChanged') CheckedItemArrayChanged = new EventEmitter<AdvancedSearchResultMemberItemArray>();

    private licenseManager: LicenseManager = new LicenseManager();
    private licenseManagerSubscription: Subscription;
    private MemberClass: Member = new Member();

    checkedItemArray: AdvancedSearchResultMemberItemArray = new AdvancedSearchResultMemberItemArray;

    constructor(private router: Router, private windowService: WindowService) {
    }

    ngOnInit() {
        this.licenseManagerSubscription = this.licenseManager.OnIsBusyChanged.subscribe(isBusy => { this.IsBusy = isBusy });
    }

    ngOnDestroy() {
        this.licenseManagerSubscription.unsubscribe();
    }

    onMemberClick(id: number, event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.router.navigate(['/member-profile', id]);
        this.ItemSelected.emit(true);
    }

    onLicenseClick(license: License, event: any) {
        event.preventDefault();
        event.stopPropagation();

        this.IsBusy = true;
        let manager = new LicenseManager()
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(license.Key, true);
    }

    onItemCheck(Item: AdvancedSearchResultMemberItem) {
        if (this.checkedItemArray.find(x => x.ID == Item.ID) == undefined)
            this.checkedItemArray.push(Item);
        else
            this.checkedItemArray.splice(this.checkedItemArray.indexOf(Item), 1);

        this.CheckedItemArrayChanged.emit(this.checkedItemArray);
    }

    packageTypeToString(ptype: LicensePackageTypes): string {
        return LicensePackageTypes[ptype];
    }

    sortBy(sortVar1: string, sortVar2: string = '') {
        this.AdvancedSearchResult = SortBot.SortAuto(this.AdvancedSearchResult, sortVar1, sortVar2);
    }

    sortByMemberType() { }

    nameForMemberType(type: number) {
        return Member.GetMemberPersonType(type);
    }

    selectAllItems() {
        this.AdvancedSearchResult.forEach((e, i) => {
            this['i' + i] = true;
        });
        this.checkedItemArray = Object.assign([], this.AdvancedSearchResult);
        // this.checkedItemArray = this.SearchResult.Members;
        this.CheckedItemArrayChanged.emit(this.checkedItemArray);
    }

    deselectAllItems() {
        this.AdvancedSearchResult.forEach((e, i) => {
            this['i' + i] = false;
        });
        this.checkedItemArray.splice(0, this.checkedItemArray.length);
        this.CheckedItemArrayChanged.emit(this.checkedItemArray);
    }

    swapSelectedItems() {
        this.AdvancedSearchResult.forEach((e, i) => {
            this['i' + i] = !this['i' + i];
            if (this.checkedItemArray.find(x => x.ID == e.ID) == undefined)
                this.checkedItemArray.push(e);
            else
                this.checkedItemArray.splice(this.checkedItemArray.indexOf(e), 1);
        });


        this.CheckedItemArrayChanged.emit(this.checkedItemArray);
    }


    GetMemberLinkURL(id: number): string {

        return '/member-profile/' + id;
    }

    ScrollToTop() {

    }


}
